import React, { useState, useRef } from 'react';
import Cleave from 'cleave.js/react';

const PhoneInput = ({ 
  value = "", 
  onChange, 
  required = false,
  name,
  label,
  placeholder
}) => {
  const [blurred, setBlurred] = useState(false);
  const inputRef = useRef(null);

  const handleChange = (e) => {
    onChange(e);
  };

  const hasError = () => {
    return value.replace(/[^0-9]/g, "").length < 10;
  };

  const onBlur = (e) => {
    setBlurred(true);
  };

  return (
    <div className="half">
      <label htmlFor={name}>{label}</label>
      <Cleave
        id={name}
        ref={inputRef}
        className={`field ${blurred && hasError() ? 'missing-required' : ''}`}
        type="tel"
        name={name}
        value={value}
        placeholder={placeholder}
        options={{ 
          blocks: [3, 3, 4], 
          delimiter: "-", 
          numericOnly: true 
        }}
        onChange={handleChange}
        onBlur={onBlur}
        required={required}
        aria-invalid={blurred && hasError()}
        aria-describedby={blurred && hasError() ? `${name}-error` : undefined}
      />
      {blurred && hasError() && (
        <div 
          id={`${name}-error`}
          className="error-message"
          role="alert"
        >
          Phone number must include 10 digits
        </div>
      )}
    </div>
  );
};

export default PhoneInput;
